import {AfterViewChecked, Component, OnDestroy, OnInit} from '@angular/core';
import {MyDeviceRequestContainerModel} from '../../models/my-device-request-container.model';
import {MyNotDeviceRequestContainerModel} from '../../models/my-not-device-request-container.model';
import {of, Subject, Subscription} from 'rxjs';
import {ProductCategoryTypeEnum} from '../../enums/product-category-type.enum';
import {EditModalService} from '../../services/edit-modal.service';
import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {ProductModel} from '../../models/product.model';
import {IFilterCheckbox} from '../../models/filter-checkbox.interface';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-add-devices-to-order-modal',
    templateUrl: './add-devices-to-order-modal.component.html',
    styleUrls: ['./add-devices-to-order-modal.component.scss']
})
export class AddDevicesToOrderModalComponent extends ModalDialogV3 implements OnInit, OnDestroy, AfterViewChecked {

    // tslint:disable:max-line-length
    private changedContainers = [];

    public devicesContainers: MyDeviceRequestContainerModel[];
    public filteredDevicesContainers: MyDeviceRequestContainerModel[];


    public searchPhrase: string;
    public lowerCaseActiveSearchPhrase: string;

    private searchTerm = new Subject<string>();
    private searchTermSub: Subscription;

    private isSpinnerHideden = false;

    public tabs = [
        {tabName: 'Alle Produkte', tabId: 'ALL-PRODUCTS-TAB'},
        {tabName: 'Nur Zubehör', tabId: 'ACCESSORIES-TAB'},
        {tabName: 'Full Service Pack', tabId: 'WARRANTIES-TAB'}
    ];

    public topFilterCheckBoxes: IFilterCheckbox[] = [
        {name: 'scanner', label: 'Scanner', isSelected: false, value: ProductCategoryTypeEnum.SCANNER},
        {name: 'drucker', label: 'Drucker', isSelected: false, value: ProductCategoryTypeEnum.PRINTER},
        {name: 'mfc', label: 'MFC/DCP', isSelected: false, value: ProductCategoryTypeEnum.MFC},
        {name: 'faxgerate', label: 'Faxgeräte', isSelected: false, value: ProductCategoryTypeEnum.FAX},
    ];

    public bottomFilterCheckBoxes: IFilterCheckbox[] = [
        {name: 'nur-print-smart', label: 'MPS-fähig', isSelected: false, value: undefined},
    ];

    public activeTopFilterCheckBoxes: IFilterCheckbox[] = null;
    public activeBottomFilterCheckBoxes: IFilterCheckbox[] = null;
    public isFilterValueChanged = false;

    constructor(
                public editModalService: EditModalService,
                private modalVisibilityService: ModalVisibilityService
    ) {
        super();
    }

    public async ngOnInit() {
        this.init();
        this.searchTermSub = this.searchTerm.asObservable().pipe(
            debounceTime(400),
            distinctUntilChanged(),
            switchMap((value) => of(value))
        ).subscribe(searchPhrase => this.applyFilter(searchPhrase));

    }

    ngAfterViewChecked(): void {
        if (!this.isSpinnerHideden) {
            if (this.modalParams.model['hideSpinner']) {
                this.editModalService.announceActiveSpinnerIdChange(null);
            }
            this.isSpinnerHideden = true;
        }
    }

    public init() {
        const dialogModel = this.editModalService.getDialogModel();
        this.devicesContainers = dialogModel.availableDevicesContainers.filter(dc => dc.itemToOrder.visibleToChannelPartners !== false);
        this.filteredDevicesContainers = this.devicesContainers;

    }

    public onCancelBtnClicked() {
        if (this.changedContainers?.length) {
            this.announceModelChanged({action: 'RESET', containers: this.changedContainers});
        }
        this.close();
    }

    public onSubmitBtnClicked() {
        this.announceModelChanged({action: 'SUBMIT', containers: null});
        this.close();
    }


    public isSmartPrint(device: ProductModel): boolean {
        return device.printSmart;
    }


    public onDeviceCheckboxClicked(deviceContainer: MyDeviceRequestContainerModel) {
        this.changedContainers.push(deviceContainer);
        // if (!deviceContainer.containerSharedMetadata.addToProductOrderList) {
        //     deviceContainer.accessories.forEach(accessory => accessory.containerSharedMetadata.addToProductOrderList = false);
        // }

    }

    public onSubItemCheckboxClicked(accessoryContainer: MyNotDeviceRequestContainerModel) {
        this.changedContainers.push(accessoryContainer);
        // if (accessoryContainer.containerSharedMetadata.addToProductOrderList) {
        //     accessoryContainer.parent.containerSharedMetadata.addToProductOrderList = true;
        // }
    }


    public onResetBtnClicked() {
        this.filteredDevicesContainers = this.devicesContainers;
        this.topFilterCheckBoxes.forEach(filterItem => {
            filterItem.isSelected = false;
        });
        this.activeTopFilterCheckBoxes = null;
        this.bottomFilterCheckBoxes.forEach(filterItem => {
            filterItem.isSelected = false;
        });
        this.activeBottomFilterCheckBoxes = null;

        this.searchPhrase = '';
        this.announceSearchTermChanged('');

    }


    public onFilterBtnClicked() {
        this.applyFilter();
    }

    public onFilterCheckboxValueChange() {
        this.isFilterValueChanged = true;
        this.applyFilter();
    }


    private applyFilter(searchPhrase?: string) {

        // console.log('searchPhrase', searchPhrase);

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('applyFilter');
        this.isFilterValueChanged = false;
        // activate filter only if it contains some value to filter with
        this.activeTopFilterCheckBoxes = this.topFilterCheckBoxes.some(filterItem => filterItem.isSelected) ?
            this.topFilterCheckBoxes : null;
        this.activeBottomFilterCheckBoxes = this.bottomFilterCheckBoxes.some(filterItem => filterItem.isSelected) ?
            this.bottomFilterCheckBoxes : null;

        if (searchPhrase !== undefined) {
            this.lowerCaseActiveSearchPhrase = searchPhrase.trim().toLowerCase();
        }


        this.filteredDevicesContainers = Object.assign([], this.devicesContainers);


        if (this.activeTopFilterCheckBoxes || this.activeBottomFilterCheckBoxes) {
            this.filteredDevicesContainers = this.filteredDevicesContainers.filter(
                dc => this.deviceContainerMatchCheckBoxesSearchCriteria(dc));

        }


        if (!!this.lowerCaseActiveSearchPhrase) {

            const reFilteredDC = [] as MyDeviceRequestContainerModel[];
            this.filteredDevicesContainers.forEach(fdc => {
                if (this.containerMatchTextSearchCriteria(fdc)) {
                    // if the product match, add product with all children to the list
                    reFilteredDC.push(fdc);
                } else {
                    // if some of children match, add device whit only children which match the criteria
                    const fdcCopy = Object.assign({}, fdc) as MyDeviceRequestContainerModel;
                    fdcCopy.accessories = fdcCopy.accessories.filter(ac => this.containerMatchTextSearchCriteria(ac));
                    fdcCopy.warranties = fdcCopy.warranties.filter(wc => this.containerMatchTextSearchCriteria(wc));

                    if (fdcCopy.accessories.length || fdcCopy.warranties.length) {
                        reFilteredDC.push(fdcCopy);
                    }
                }
            });
            this.filteredDevicesContainers = reFilteredDC;
        }
    }

    private deviceContainerMatchCheckBoxesSearchCriteria(deviceContainer: MyDeviceRequestContainerModel): boolean {

        const topFilterTestResult: boolean = !this.activeTopFilterCheckBoxes ||  // return true if the filter is not active
            this.activeTopFilterCheckBoxes.some(filterItem =>

                filterItem.isSelected && filterItem.value === ProductCategoryTypeEnum[deviceContainer.itemToOrder.category]);


        const bottomFilterTestResult: boolean = !this.activeBottomFilterCheckBoxes ||  // return true if the filter is not active
            this.activeBottomFilterCheckBoxes.some(filterItem => filterItem.isSelected && deviceContainer.itemToOrder.printSmart);

        return topFilterTestResult && bottomFilterTestResult;
    }


    private containerMatchTextSearchCriteria(container: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel): boolean {
        return !this.lowerCaseActiveSearchPhrase ||
            // tslint:disable-next-line:max-line-length
            (container.itemToOrder.modelTitle && container.itemToOrder.modelTitle.toLowerCase().indexOf(this.lowerCaseActiveSearchPhrase) > -1) ||
            (container.itemToOrder.sku && container.itemToOrder.sku.toLowerCase().indexOf(this.lowerCaseActiveSearchPhrase) > -1) ||

            (container.itemToOrder.modelNumber && container.itemToOrder.modelNumber.toLowerCase().indexOf(this.lowerCaseActiveSearchPhrase) > -1);
    }

    public announceSearchTermChanged(term: string) {
        this.searchTerm.next(term);
    }

    public ngOnDestroy(): void {
        if (this.searchTermSub) {
            this.searchTermSub.unsubscribe();
        }

    }
}
